var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0013 5.73398L42.8263 38.259H5.17628L24.0013 5.73398ZM0.85128 35.759C-1.07372 39.084 1.32628 43.259 5.17628 43.259H42.8263C46.6763 43.259 49.0763 39.084 47.1513 35.759L28.3263 3.23398C26.4013 -0.0910156 21.6013 -0.0910156 19.6763 3.23398L0.85128 35.759ZM21.5013 18.259V23.259C21.5013 24.634 22.6263 25.759 24.0013 25.759C25.3763 25.759 26.5013 24.634 26.5013 23.259V18.259C26.5013 16.884 25.3763 15.759 24.0013 15.759C22.6263 15.759 21.5013 16.884 21.5013 18.259ZM21.5013 30.759H26.5013V35.759H21.5013V30.759Z",
    fill: "url(#paint0_linear_10981_353)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10981_353",
    x1: 24.0013,
    y1: 0.740234,
    x2: 6.04659,
    y2: 72.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F06543"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.08e6fd2976b25d35c1cafb07d61dea77.svg";
export { ForwardRef as ReactComponent };